import { Formik } from 'formik'
import React from "react"
import { useState } from "react"
import { useParams } from 'react-router-dom'
import Header from '../../components/Header'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Box, Button, TextField } from '@mui/material'

import { Select, MenuItem } from '@mui/material'

import * as Constants from '../../constants'

const EditLivestream = () => {
  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })
  const [isAdmin, setIsAdmin] = useState(false)

  const username = useParams().id

  const handleSelect = (e) => {
    console.log(e.target.value)
    setIsAdmin(e.target.value)
  }

  const isNonMobile = useMediaQuery('(min-width:600px)')

  const handleFormSubmit = (values) => {
    if (values.newpass !== values.confirmpass) {
      alert('As senhas não conferem')
    } else {
      fetch(Constants.HOST + '/editLivestream', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          token: JSON.parse(localStorage.getItem('user_data')).token,
          username: username,
          newpass: values.newpass,
          isAdmin: isAdmin,
        }),
      })
        .then((response) => {
          if (response.status !== 400 && response.status !== 200) {
            setError({
              error: true,
              message: 'Erro de comunicação com o servidor',
            })
            setSuccess({ success: false, message: '' })
          } else {
            response.json().then((data) => {
              if (data.success) {
                setError({ error: false, message: '' })
                setSuccess({
                  success: true,
                  message: 'Usuário editado com sucesso',
                })
              } else {
                setSuccess({ success: false, message: '' })
                setError({ error: true, message: data.message })
              }
            })
          }
        })
        .catch(() => {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        })
    }
  }

  return (
    <Box m="20px">
      <Header title="Editar Usuário" />

      <h4 style={{ textAlign: 'left' }}>
        Senha (deixe em branco para manter a mesma senha)
      </h4>
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
        {({ values, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="20px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Nova senha"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.newpass}
                name="newpass"
                sx={{ gridColumn: 'span 2' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Confirme a nova senha"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.confirmpass}
                name="confirmpass"
                error={
                  touched.confirmpass && values.confirmpass !== values.newpass
                }
                sx={{ gridColumn: 'span 2' }}
                autoComplete="off"
              />
              <h4 style={{ textAlign: 'left' }}>Tipo de Usuário</h4>
              <Select
                fullWidth
                label="Tipo de usuário"
                value={isAdmin}
                onChange={handleSelect}
                onBlur={handleBlur}
                name="type"
                sx={{ gridColumn: 'span 4', fontColor: 'white' }}
              >
                <MenuItem value={true}>Administrador</MenuItem>
                <MenuItem value={false} selected>
                  Operador
                </MenuItem>
              </Select>
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Enviar
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  )
}

const initialValues = {
  newpass: '',
  confirmpass: '',
}

export default EditLivestream
